import { render } from "./Enoncer.vue?vue&type=template&id=05b17a5c&scoped=true"
import script from "./Enoncer.vue?vue&type=script&lang=js"
export * from "./Enoncer.vue?vue&type=script&lang=js"

import "./Enoncer.vue?vue&type=style&index=0&id=05b17a5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b17a5c"]])

export default __exports__